<template>
	<div class="container">
		<!--页面开始-->
		<div class="step_box">
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_12.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit"></div>
				<div class="step_txt">
					<div>
						Gently squeeze the tube and dispense 3 drops of solution into the sample well.
					</div>
				</div>
			</div>
			<div class="txt_note">
				Note: A false negative or invalid result may occur if less than 3 drops of fluid are added to the Sample Well.
			</div>
		</div>
		<div class="btn_box">
			<van-button
				type="primary"
				block
				round
				color="linear-gradient(to right, #a74af2, #5949f2)"
				ref="toggle1"
				@click="goCountDown"
			>
				Start 10 min timer
			</van-button>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			noSleep: null,  //屏幕常亮对象
		}
	},
	beforeCreate() {
		document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
	},
	created(){
		//
	},
	mounted() {
		let that = this;
		//if(!sessionStorage.getItem('isOnce')){
			that.$nextTick(() => {
				//监听屏幕常亮事件
				that.noSleep = new NoSleep();
				that.$refs.toggle1.addEventListener('click', function() {
					that.noSleep.enable();  //开启常亮
					//sessionStorage.setItem('isOnce', 'false');
				}, false);
			});
		//}
	},
	watch: {
		//
	},
	methods: {
		goCountDown() {
			this.$router.push({path:'/countdown', query: {type: '10'}});
		},
	},
	beforeDestroy() {
		document.querySelector('body').removeAttribute('style');
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
.container{
	/* position: absolute;
	height: 100%;
	background-color: #fbfbfb; */
}
.step_box{
	position: relative;
	margin: 0.32rem 0.32rem 0 0.32rem;
	border-radius: 0.32rem;
	box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
	overflow: hidden;
	background-color: #ffffff;
	padding: 1rem 0.32rem 1rem 0.32rem;
	border: 1px solid #E9E9E9;
	/* padding: 1.14rem 0.573rem 0 0.64rem; */
}
.step_box img{
	width: 100%;
	height: auto;
}
.step_box .step_el{
	position: relative;
}
.step_box .step_el .tit{
	position: absolute;
	top: 0.32rem;
	left: 0.32rem;
	font-size: 0.533rem;
	color: #333333;
	font-weight: bold;
}
.btn_box{
	/* padding:0.693rem 0.9rem 1.107rem 0.9rem; */
	position: fixed;
	bottom: 1.107rem;
	width: 100%;
	padding: 0 0.9rem 0 0.9rem;
}
.step_box img, .btn_box img{width: 100%;}

/*步骤下说明文字*/
.step_txt{
	padding: 0.427rem 0 0.64rem 0;
	text-align: left;
	color: #333333;
}
.txt_note{
	padding: 0.373rem 0.45rem;
	background-color: #ffcaca;
	color: #720000;
	border-radius: 8px;
	border: 1px #720000 solid;
	font-weight: bold;
}

>>> .van-button{height: 1.2rem;}
>>> .van-button__text{color: #ffffff;font-size: 0.48rem;font-weight: bold;}

@media screen and (min-device-width : 768px){
	.btn_box{
		position: relative;
		width: 100%;
		padding: 3rem 0.9rem 0 0.9rem;
	}
} 
</style>
